import { Button } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'
import withStyles from '@mui/styles/withStyles'

const useStyles = makeStyles(theme => ({
  menuIcon: {
    marginRight: '0.625rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main
  },

  menuItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.5rem 1.25rem',
    cursor: 'pointer',
    fontSize: theme.size.sm
  },

  menu: {
    '& .MuiList-padding': {
      padding: '0'
    }
  }
}))

export const StyledButton = withStyles(theme => ({
  root: {
    borderRadius: '50%',
    width: '2rem',
    minWidth: '2rem',
    height: '2rem',
    minHeight: '2rem',
    background: `linear-gradient(276deg, ${theme.gradient.button.start} 0%, ${theme.gradient.button.stop} 100%)`,
    fontSize: theme.size.xl,
    color: 'white'
  }
}))(Button)

export default useStyles
